module.exports = __webpack_public_path__ + "static/media/icon-catalog-info.27298796.svg";